<template>
  <div class="page-head">
    <h1>Community & Talks</h1>
    <p class="lead">
      {{
        t(
          "J'aime apprendre avec les autres : je co-dirige une communauté, j'organise des événements et je prends la parole quand on m'invite.",
          "I love learning with others: I co-lead a community, organize events and speak when I'm invited."
        )
      }}
    </p>
  </div>

  <section class="sec">
    <div class="sec-head">
      <h2><Users />Dev Girls</h2>
      <a class="link" href="https://www.devgirls.org" target="_blank" rel="noopener">devgirls.org <ArrowUpRight /></a>
    </div>
    <div class="mission">
      <div v-if="lang === 'fr'">
        <p>
          En janvier 2025, j'ai co-fondé <a class="mark" href="https://www.devgirls.org" target="_blank" rel="noopener">Dev Girls</a>
          avec Linda Mballa. Sa mission : <b>encourager et accompagner les femmes passionnées par la tech</b>. La communauté compte
          aujourd'hui plus de 1000 membres.
        </p>
        <p class="next">De mon côté, j'organise des événements, je modère des tables rondes et je contribue au site de la communauté.</p>
      </div>
      <div v-else>
        <p>
          In January 2025, I co-founded <a class="mark" href="https://www.devgirls.org" target="_blank" rel="noopener">Dev Girls</a>
          with Linda Mballa. Its mission: <b>encourage and support women passionate about tech</b>. The community now has more than
          1,000 members.
        </p>
        <p class="next">On my side, I organize events, moderate panels and contribute to the community's website.</p>
      </div>
      <div class="photo">
        <img :src="photo" :alt="t('Arolle Fona prend la parole lors d\'un événement Dev Girls', 'Arolle Fona speaking at a Dev Girls event')" />
      </div>
    </div>
  </section>

  <section class="sec">
    <div class="sec-head">
      <h2><Mic />{{ t("Talks et événements", "Talks and events") }}</h2>
    </div>
    <ul class="events">
      <li v-for="(e, i) in events" :key="i">
        <time>{{ t(e.date) }}</time>
        <span>
          <a v-if="e.url" class="t" :href="e.url" target="_blank" rel="noopener">{{ t(e.title) }}</a>
          <span v-else class="t">{{ t(e.title) }}</span>
          <small>{{ t(e.text) }}</small>
        </span>
        <span class="badge pink">{{ t(e.role) }}</span>
      </li>
    </ul>
  </section>

  <section class="sec">
    <div class="sec-head">
      <h2><MonitorPlay />Interview</h2>
    </div>
    <div class="embed">
      <iframe
        :src="`https://www.youtube-nocookie.com/embed/${ytId}`"
        :title="t('Interview d\'Arolle Fona par Horizon IA', 'Arolle Fona interviewed by Horizon IA')"
        loading="lazy"
        allow="accelerometer; encrypted-media; picture-in-picture"
        allowfullscreen
      ></iframe>
    </div>
    <p class="muted caption">
      {{ t("« Ce mouvement tech en Afrique est en train de tout changer », Horizon IA.", "“This tech movement in Africa is changing everything”, Horizon IA (in French).") }}
    </p>
  </section>
</template>

<script>
import { ArrowUpRight, Mic, MonitorPlay, Users } from "lucide-vue-next";
import { DEVGIRLS_PHOTO, EVENTS, YT_ID } from "@/content";
import { useI18n } from "@/i18n";

export default {
  name: "CommunityPage",
  components: { ArrowUpRight, Mic, MonitorPlay, Users },
  setup: () => ({ ...useI18n(), events: EVENTS, photo: DEVGIRLS_PHOTO, ytId: YT_ID }),
};
</script>

<style scoped>
.next {
  margin-top: 12px;
}
.photo img {
  object-position: 70% 30%;
}
.caption {
  margin-top: 10px;
}
</style>
